export default {
    state: {
        unit_id: null,
        units: [],
        unit: [],
        errors: {},
        form: {
            code: '',
            name: '',
            unit: '',
        },
        table: {
            fields: [
                {key: 'id', label: 'Code', sortable: true},
                {key: 'name', label: 'Name', sortable: true},
                {key: 'unit', label: 'Base Unit', tdClass: 'text-muted'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },
        meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
    },

    getters: {
        getProductUnitTableFields: state => state.table.fields,

        getProductUnitMeta: state => state.meta,

        getProductUnitsForm: state => state.form,

        getProductUnitsErrors: state => state.errors,

    },

    mutations: {
        resetProductUnitsMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setProductUnits: (state, payload) => {
            state.units = payload;
        },

        setProductUnitsMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setProductUnitsErrors: (state, payload) => {
            state.errors = payload;
        },

        setProductUnit: (state, payload) => {
            state.unit = payload;
        },

        setProductUnitsForm: state => {
            state.form = {
                name: '',
                base_unit_id: '',
            };

            state.errors = {};
        },


    },

    actions: {
        fetchProductUnits: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };


            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            const units = {
                "data": [
                    {
                        "unit_id": 1,
                        "label": "Mobile",
                        "data": {
                            "type": "Product Units",
                            "attributes": {
                                "code": "PRU000001",
                                "name": "Mobile",
                                "unit": "lb",
                                "status": "Active"
                            }
                        },
                        "links": {"self": "units\/1"}
                    },
                    {
                        "unit_id": 2,
                        "label": "Mobile",
                        "data": {
                            "type": "Product Units",
                            "attributes": {
                                "code": "PRU000002",
                                "name": "Mobile",
                                "unit": "lb",
                                "status": "Active"
                            }
                        },
                        "links": {"self": "units\/2"}
                    },
                    {
                        "unit_id": 3,
                        "label": "Mobile",
                        "data": {
                            "type": "Product Units",
                            "attributes": {
                                "code": "PRU000003",
                                "name": "Mobile",
                                "unit": "lb",
                                "status": "Active"
                            }
                        },
                        "links": {"self": "units\/3"}
                    }
                ],
                "links": {
                    "self": "\/units",
                    "first": "http:\/\/pilot.test\/api\/inventory\/products\/units?page=1",
                    "last": "http:\/\/pilot.test\/api\/inventory\/products\/units?page=3",
                    "prev": null,
                    "next": "http:\/\/pilot.test\/api\/inventory\/products\/units?page=2"
                },
                "meta": {
                    "current_page": 1,
                    "from": 1,
                    "last_page": 3,
                    "path": "http:\/\/pilot.test\/api\/inventory\/products\/units",
                    "per_page": "10",
                    "to": 10,
                    "total": 21
                }
            };

            return new Promise((resolve, reject) => {
                commit('setProductUnits', units);

                commit('setProductUnitsMeta', units.meta);

                resolve(units);
            });
        },

        fetchEditProductUnit: ({state, commit}, unit_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + unit_id + '/edit')
                    .then(response => {
                        state.unit_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitProductUnits: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setProductUnitsErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        updateProductUnits: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.unit_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setProductUnitsErrors', error.response.data.errors);

                        reject();
                    });
            })
        },
    }
}
